import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { DoubleArrow, CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import KPTimePicker from "../../../components/KPTimePicker";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import {
  insertProject,
  updateProject,
  getProfileInfoByProfileId,
  checkDuplicateProject,
} from "../../../reducer/project/action";
import { uploadMultiFile } from "../../../reducer/file/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import { notification } from "../../../reducer/home/action";
import moment from "moment";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";
import DuplicateCheckModal from "../../../components/Project/DuplicateCheckModal";

function ProjectInsertModal(props) {
  const { inserting, setInserting } = props;

  const currentYear = getCurrentSchoolYear();

  const [detail, setDetail] = useState(null);
  const [values, setValues] = useState({
    startAt: `01/01/${currentYear}`,
    finishAt: `01/01/${currentYear}`,
    purposeId: 5,
    type: "basic",
    level: "school",
    status: "processing",
    departmentId: props.profileDepartments?.[0]?.id || null,
  });
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [studentHelperText, setStudentHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(null);

  // Tự gán bản thân vào danh sách tác giả
  React.useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInProject: "main",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [props.inserting, props.profile?.id]);

  // Chọn thành viên để lấy đề tài thì load lại đề tài của ông ấy
  React.useEffect(() => {
    if (values?.profileIdToSelectId) props.getProfileInfoByProfileId(values?.profileIdToSelectId);
  }, [values?.profileIdToSelectId]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  };

  const valueFormat = (value) => {
    const temp = value.replace(/\D/g, "").replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ".");
    return temp;
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInProject: "member",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleChangeStudentList = (index, name, value) => {
    const temp = studentList;
    const tempElm = studentList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setStudentList([...temp]);
  };

  const handleInsertStudent = () => {
    const temp = studentList;
    temp.push({
      studentName: "",
      studentCode: "",
      class: "",
      major: "",
      cohort: "",
      identity: "",
      isInternal: false,
      externalName: "",
      roleInProject: "member",
    });
    setStudentList([...temp]);
  };

  const handleRemoveStudent = (index) => {
    const temp = studentList;
    temp.splice(index, 1);
    setStudentList([...temp]);
  };

  const checkForDuplicates = async (title) => {
    if (!title || title.trim() === "") {
      return { hasDuplicates: false, data: [] };
    }

    const result = await props.checkDuplicateProject({
      publicationType: "researchProjects",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      return { hasDuplicates: true, data: result.data };
    }

    return { hasDuplicates: false, data: [] };
  };

  const handleSelectDuplicate = (item) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
    setInserting(false);

    // Reset Insert modal
    setValues(null);
    setProfileList([]);
    setStudentList([]);
    setNewFiles([]);
    setHelperText(false);
    setStudentHelperText(false);

    // Trigger Update modal with the selected duplicate item
    const projectToEdit = {
      ...item.researchProject,
      researchProjectProfile: item.researchProjectProfile || [],
      _fromDuplicate: true,
    };

    if (props.setUpdating) {
      props.setUpdating(projectToEdit);
    }
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    // If user closes modal, proceed with pending submission
    if (pendingSubmit) {
      proceedWithSubmit(pendingSubmit);
      setPendingSubmit(null);
    }
  };

  const proceedWithSubmit = async (submitData) => {
    setInserting(false);

    const response = await props.insertProject(props.profile?.id, submitData);
    if (response.success && newFiles.length > 0) {
      const uploadResult = await props.uploadMultiFile(response.data.id, newFiles, "researchProject");
      if (uploadResult.success) {
        await props.updateProject(response.data.id, {
          ...response.data,
          fileUrl: uploadResult.data.join("||"),
        });
      }
    }
    if (response.success) {
      props.statisticUnaccepted({
        departmentId: 0,
        profileId: props.profile?.id,
      });
      if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
    }

    setValues(null);
    setProfileList([]);
    setStudentList([]);
    setStudentHelperText(false);
    setNewFiles([]);
  };

  const handleSubmit = async (e) => {
    // check title, code, numOfMember
    if (!values?.title || !values?.numOfMember || values?.numOfMember <= 0) {
      setHelperText(true);
      return;
    }

    // Validate student list - only if there are students added
    const hasInvalidStudents =
      studentList.length > 0 &&
      studentList.findIndex((e) => e.studentName === "" || e.identity === "" || !e.roleInProject) >= 0;

    if (hasInvalidStudents) {
      setStudentHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    // Check for duplicates
    const duplicateCheck = await checkForDuplicates(values?.title);

    const submitData = {
      ...values,
      dashboardYear: new Date(dateFormat(values?.startAt || moment().format("YYYY-MM-DD"))).getFullYear(),
      researchProjectProfile: [...profileList, ...studentList],
      startAt: dateFormat(values?.startAt || moment().format("YYYY-MM-DD")),
      finishAt: dateFormat(values?.finishAt || moment().format("YYYY-MM-DD")),
      acceptedDate: dateFormat(values?.acceptedDate),
      profileId: parseInt(values?.profileIdToSelectId),
      patentId: values?.typeToSelectId === "patent" ? values?.selectId : 0,
      productContractId: values?.typeToSelectId === "productContract" ? values?.selectId : 0,
      scientificResearchId: values?.typeToSelectId === "scientificResearch" ? values?.selectId : 0,
      solutionId: values?.typeToSelectId === "solution" ? values?.selectId : 0,
    };

    if (duplicateCheck.hasDuplicates) {
      // Show duplicate modal
      setDuplicateList(duplicateCheck.data);
      setDuplicateModalOpen(true);
      setPendingSubmit(submitData);
      return;
    }

    // No duplicates, proceed with submission
    proceedWithSubmit(submitData);
  };

  const handleOpenUploadModal = () => {};
  const handleCloseUploadModal = () => {};

  const handleCloseInsertModal = () => {
    setInserting(false);
    setValues(null);
    setProfileList([]);
    setStudentList([]);
    setNewFiles([]);
    setHelperText(false);
    setStudentHelperText(false);
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  const selectList = [];
  if (values?.typeToSelectId) {
    props[values?.typeToSelectId + "s"].forEach((e) => selectList.push(e[values?.typeToSelectId]));
  }

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type?.includes("researchProject")
  // );

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type?.includes("researchProject"));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  return (
    <Dialog fullWidth keepMounted maxWidth="lg" open={inserting} onClose={handleCloseInsertModal} disableBackdropClick>
      <DialogTitle>
        {/* Thêm đề tài nghiên cứu (Chỉ những đề tài đã đượ nghiệm thu) */}
        Thêm đề tài nghiên cứu
      </DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <div
            style={{
              paddingRight: 16,
            }}
          >
            <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
              <Grid item xs={7}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Tên đề tài"
                  required
                  value={values?.title || ""}
                  error={helperText && !values?.title}
                  helperText={helperText && !values?.title ? "Vui lòng nhập tên đề tài" : ""}
                  onChange={(event) => handleChangeForm("title", event.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Mã CTKH"
                  value={values?.hemisCode || ""}
                  onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  variant="outlined"
                  label="Số lượng thành viên"
                  required
                  value={values?.numOfMember || ""}
                  error={helperText && !values?.numOfMember}
                  helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng thành viên" : ""}
                  onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  size="small"
                  options={(props.departmentList || []).filter((d) => d.id !== 0)}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                    null
                  }
                  onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                  renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
                />
              </Grid>

              {/* <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã số"
                required
                value={values?.code || ""}
                error={helperText && !values?.code}
                helperText={helperText && !values?.code ? "Vui lòng nhập mã số" : ""}
                onChange={(event) => handleChangeForm("code", event.target.value)}
              />
            </Grid> */}
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="type-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Loại hình đề tài
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="type-label"
                    value={values?.type || ""}
                    onChange={(event) => handleChangeForm("type", event.target.value)}
                  >
                    <option value="basic">Cơ bản</option>
                    <option value="application">Ứng dụng</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="level-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Cấp
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="level-label"
                    value={values?.level || ""}
                    onChange={(event) => handleChangeForm("level", event.target.value)}
                  >
                    {/* <option value={null} /> */}
                    <option value="school">Cơ sở</option>
                    <option value="ministry">Bộ</option>
                    <option value="keyMinistry">Trọng điểm của bộ</option>
                    <option value="nafosted">Nafosted</option>
                    <option value="country">Nhà nước/Quốc gia</option>
                    <option value="city">Tỉnh/TP</option>
                    {/* <option value="domestic">Nhà nước/Quốc gia</option> */}
                    {/* <option value="international">Quốc gia</option> */}
                    <option value={null}>Khác</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  variant="outlined"
                  label="Sản phẩm đăng ký"
                  value={values?.productName || ""}
                  onChange={(event) => handleChangeForm("productName", event.target.value)}
                />
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  paddingLeft: 18.5,
                  lineHeight: "40px",
                  fontSize: "1em",
                  color: "rgba(0, 0, 0, 0.5)",
                }}
              >
                Thời gian thực hiện:
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Từ ngày"
                  value={values?.startAt || `01/01/${currentYear}`}
                  setValue={(newValue) => handleChangeForm("startAt", newValue)}
                />
                {values?.startAt === "dd/mm/yyyy" && (
                  <FormHelperText error>Vui lòng điền thời gian thực hiện!</FormHelperText>
                )}
              </Grid>
              <Grid item xs={1} style={{ textAlign: "center" }}>
                <DoubleArrow style={{ fontSize: 40, color: "rgba(0, 0, 0, 0.30)" }} />
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Đến ngày"
                  value={values?.finishAt || `01/01/${currentYear}`}
                  setValue={(newValue) => handleChangeForm("finishAt", newValue)}
                />
                {values?.finishAt === "dd/mm/yyyy" && (
                  <FormHelperText error>Vui lòng điền thời gian thực hiện!</FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Cơ quan chủ trì"
                  value={values?.host || ""}
                  onChange={(event) => handleChangeForm("host", event.target.value)}
                >
                  <MenuItem value={"cmc"}>Trường Đại học CMC</MenuItem>
                  <MenuItem value={"other"}>Đơn vị khác</MenuItem>
                  <MenuItem value={"other"}>CMC ATI</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Cơ quan tài trợ"
                  value={values?.sponsor || ""}
                  onChange={(event) => handleChangeForm("sponsor", event.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Giá trị"
                  value={values?.value || ""}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">VND</InputAdornment>,
                  }}
                  onChange={(event) => handleChangeForm("value", valueFormat(event.target.value))}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="status-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Tình trạng
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="status-label"
                    value={values?.status || ""}
                    onChange={(event) => handleChangeForm("status", event.target.value)}
                  >
                    {/* <option value={null} /> */}
                    <option value="processing">Đang tiến hành</option>
                    <option value="accepted">Đã nghiệm thu</option>
                    <option value="extend">Gia hạn</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Ngày nghiệm thu"
                  value={values?.acceptedDate || `01/01/${currentYear}`}
                  setValue={(newValue) => handleChangeForm("acceptedDate", newValue)}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Mục đích
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="purpose-label"
                    value={values?.purposeId === 0 ? null : (values?.purposeId ?? "none")}
                    onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                  >
                    {props.purposes
                      .filter((e) => e.name !== "bonusCalculated")
                      .map((e) => {
                        if (e.name === "timeResearch" || e.name === "other")
                          return (
                            <option key={e.id} value={e.id}>
                              {e.description}
                            </option>
                          );
                        // if (e.name === "oldPaper")
                        //   return (
                        //     <option key={e.id} value={e.id}>
                        //       Đề tài không phải Phenikaa chủ trì
                        //     </option>
                        //   );
                        return <option hidden />;
                      })}
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={3}>
              <TextField
                fullWidth
                select
                size='small'
                label='Mục đích'
                variant='outlined'
                value={values?.purposeId ?? 'none'}
                SelectProps={{ native: true }}
                onChange={(event) => handleChangeForm('purposeId', parseInt(event.target.value, 10))}
              >
                {props.purposes.filter(e => e.name !== 'bonusCalculated').map(e => {
                    if (e.name === 'timeResearch')
                      return <option key={e.id} value={e.id}>{e.description}</option>
                    if (e.name === 'oldPaper')
                      return <option key={e.id} value={e.id}>Đề tài không phải đơn vị chủ trì</option>
                    return <option hidden />
                  })
                }
              </TextField>
            </Grid> */}

              {values?.purposeId === 5 && (
                <>
                  {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Nhiệm vụ tính giờ nghiên cứu"
                      variant="outlined"
                      value={values?.timeResearchDetailCode || null}
                      onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                      InputLabelProps={{
                        shrink: !(
                          values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                        ),
                      }}
                      error={!values?.timeResearchDetailCode}
                    >
                      {timeResearchDetailList.length > 0 ? (
                        timeResearchDetailList?.map((e) => (
                          // <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                          // Sửa lại sao cho dài quá thì xuống dòng - thường dòng description dài hơn nhiều so với value - tự ngắt dòng description với max-width
                          <MenuItem key={e.code} value={e.code}>
                            <div style={{ display: "flex", flexDirection: "column", maxWidth: 800 }}>
                              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{e.description}</div>
                              <span style={{ color: "rgba(0, 0, 0, 0.54)" }}>{`${e.value}(h)`}</span>
                            </div>
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={null}>Chưa có dữ liệu</MenuItem>
                      )}
                    </TextField>
                    {!values?.timeResearchDetailCode && <FormHelperText error>Phải chọn một nhiệm vụ!</FormHelperText>}
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Ghi chú"
                  variant="outlined"
                  value={values?.note || ""}
                  multiline
                  rows={3}
                  onChange={(event) => handleChangeForm("note", event.target.value)}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values?.isOvertimeCountable || false}
                      disabled={props.role !== "sudo-admin"}
                      onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                      color="primary"
                    />
                  }
                  label="Tính giờ ngoài quy chế"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Số giờ ngoài quy chế"
                  variant="outlined"
                  value={values?.overtimeHours ?? ""}
                  disabled={props.role !== "sudo-admin" || !values?.isOvertimeCountable}
                  onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                  inputProps={{
                    min: 0,
                    step: 0.1,
                  }}
                />
              </Grid>

              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
              </Grid>
              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>

              <Grid item xs={12}>
                {profileList.map((e, index) => (
                  <Grid key={`list-${index}`} container spacing={2}>
                    <Grid item xs={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={e.isInternal !== false}
                            onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                            color="primary"
                          />
                        }
                        label="Nội bộ"
                      />
                    </Grid>
                    {e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                        <Autocomplete
                          disableClearable
                          options={props.profileList}
                          getOptionLabel={(option) => option.name}
                          value={
                            profileListFromProps?.find((profile) => profile.id === e.profileId) ||
                            profileListFromProps[0]
                          }
                          onChange={(event, profile) => {
                            if (profileList[index]?.profileId === values?.profileIdForKpi)
                              handleChangeForm("profileIdForKpi", null);
                            handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                          }}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                          )}
                        />
                      </Grid>
                    )}
                    {!e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Tên thành viên"
                          value={e?.externalName || ""}
                          onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                        />
                        {helperText && e.externalName === "" && (
                          <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                        )}
                      </Grid>
                    )}
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="roleInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                          Vai trò
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          labelId="roleInProject-label"
                          value={e?.roleInProject || "main"}
                          onChange={(event) => handleChangeProfileList(index, "roleInProject", event.target.value)}
                        >
                          <option value="main">Chủ nhiệm</option>
                          <option value="secretary">Thư ký</option>
                          <option value="member">Thành viên</option>
                          {/* <option value="mainOther">Chủ nhiệm tính hộ</option>
                        <option value="memberOther">Thành viên tính hộ</option> */}
                        </Select>
                      </FormControl>
                    </Grid>
                    {values?.purposeId === 1 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForKpi}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={e.profileId === null}
                            startIcon={
                              typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                              handleChangeForm(
                                "profileIdForKpi",
                                values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính KPI
                          </Button>
                          {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                        </FormControl>
                      </Grid>
                    )}
                    {values?.purposeId === 99999999 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForReward}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={e.profileId === null}
                            startIcon={
                              typeof values?.profileIdForReward === "number" &&
                              values?.profileIdForReward === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              handleChangeForm(
                                "profileIdForReward",
                                values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính thưởng
                          </Button>
                          {!values?.profileIdForReward && (
                            <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={1}>
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemove(index)}
                      >
                        Xoá
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth variant="outlined" onClick={handleInsert}>
                  Thêm thành viên
                </Button>
              </Grid>

              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
              </Grid>
              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>

              <Grid item xs={12}>
                {studentList.map((e, index) => (
                  <Grid key={`student-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                    <Grid item xs={5}>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên sinh viên"
                        value={e?.studentName || ""}
                        error={studentHelperText && e.studentName === ""}
                        onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                      />
                      {studentHelperText && e.studentName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Mã sinh viên"
                        value={e?.studentCode || ""}
                        error={studentHelperText && e.studentCode === ""}
                        onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                      />
                      {studentHelperText && e.studentCode === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl
                        required
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={studentHelperText && !e?.roleInProject}
                      >
                        <InputLabel
                          id={`student-roleInProject-label-${index}`}
                          style={{ padding: "0 8px", backgroundColor: "white" }}
                        >
                          Vai trò
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          labelId={`student-roleInProject-label-${index}`}
                          value={e?.roleInProject || "member"}
                          onChange={(event) => handleChangeStudentList(index, "roleInProject", event.target.value)}
                        >
                          <option value="main">Chủ nhiệm</option>
                          <option value="member">Thành viên</option>
                        </Select>
                      </FormControl>
                      {studentHelperText && !e?.roleInProject && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={1}>
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemoveStudent(index)}
                      >
                        Xóa
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Lớp"
                        value={e?.class || ""}
                        onChange={(event) => handleChangeStudentList(index, "class", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Ngành học"
                        value={e?.major || ""}
                        onChange={(event) => handleChangeStudentList(index, "major", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Khóa"
                        value={e?.cohort || ""}
                        onChange={(event) => handleChangeStudentList(index, "cohort", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Số CMND/CCCD"
                        value={e?.identity || ""}
                        onChange={(event) => handleChangeStudentList(index, "identity", event.target.value)}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth variant="outlined" onClick={handleInsertStudent}>
                  Thêm sinh viên
                </Button>
              </Grid>
            </Grid>
          </div>
          <div
            style={{
              flexDirection: "column",
              display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
            }}
          >
            <EmploymentContractTable
              contract={detail}
              setDetail={setDetail}
              contractList={contractList}
              kpiIdForKpi={values?.kpiIdForKpi}
              contractIdForKpi={values?.contractIdForKpi}
              handleChangeForm={handleChangeForm}
              values={values}
              setValues={setValues}
            />
            <EmploymentContractDetailTable kpi={detail} />
          </div>
        </div>
        <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
            File minh chứng
          </Typography>
          <MultiFileManager
            fileUrls={[]}
            setFileUrls={() => {}}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={false}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div style={{ float: "right" }}>
            <Button variant="outlined" color="secondary" onClick={handleCloseInsertModal} style={{ marginRight: 4 }}>
              Huỷ
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleSubmit()}
              disabled={values?.purposeId === 5 && !values?.timeResearchDetailCode}
            >
              Xác nhận
            </Button>
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        onClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
  // ----------- //
  scientificResearchs: select(state, "projectReducer", "scientificResearchs"),
  solutions: select(state, "projectReducer", "solutions"),
  patents: select(state, "projectReducer", "patents"),
  productContracts: select(state, "projectReducer", "productContracts"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertProject: (profileId, payload) => dispatch(insertProject(profileId, payload)),
  updateProject: (profileId, payload) => dispatch(updateProject(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  getProfileInfoByProfileId: (id) => dispatch(getProfileInfoByProfileId(id)),
  checkDuplicateProject: (payload) => dispatch(checkDuplicateProject(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ProjectInsertModal));

